export default "__VITE_ASSET__CMkHiI0W__"